// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1MH2R","range":"MonthRangeSwitch_range__1_nVH","disabled":"MonthRangeSwitch_disabled__18Tt4"};